import { useSearch } from '@tanstack/react-router';

import { Flex } from '@repo/ui/Flex';
import { Icon } from '@repo/ui/Icon';

import s from './NarvarFooter.module.css';
import { getRetailerFromUrl } from '../../utils/getRetailerFromUrl';

export const PRIVACY_LINKS = {
  en: 'https://corp.narvar.com/privacy-policy/',
  ja: 'https://corp.narvar.com/jp/terms-of-service',
};

type Language = keyof typeof PRIVACY_LINKS;

export const NarvarFooter = () => {
  const params = useSearch({ strict: false });
  const locale = params?.locale ?? 'en_US';
  const retailerName = getRetailerFromUrl();
  const language = (locale.split('_')[0] ?? 'en') as Language;

  return (
    <div className={s.wrapper}>
      <Flex
        alignItems="center"
        as="footer"
        gap="g-16"
        justifyContent="space-between"
        padding="p-24"
        className={s.container}
      >
        <Flex gap="g-8" className={s.legal}>
          <span>©2025 Narvar</span>
          <span>•</span>
          <span>
            <a
              href={PRIVACY_LINKS[language] ?? PRIVACY_LINKS.en}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </span>
        </Flex>
        <a
          className={s.poweredBy}
          href={`https://corp.narvar.com/survey?product=pdx&retailer_name=${retailerName}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon className={s.narvarIconDark} name="narvar" size="font" />
          Powered by Narvar
        </a>
      </Flex>
    </div>
  );
};
